<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>Visit Us</h3>
          <p>2 St Lawrence Steps, St Benedicts St</p>
          <p>Norwich, NR2 4PE</p>
          <p>United Kingdom</p>
        </div>

        <div class="footer-section">
          <h3>Opening Hours</h3>
          <p>
            <span style="font-weight: bold">Bookshop:</span> Wednesday -
            Saturday: 11am - 5pm
          </p>
          <p>
            <span style="font-weight: bold">Events:</span>
            <router-link to="/events" class="events-link"
              >See the events page</router-link
            >
          </p>
        </div>

        <div class="footer-section">
          <h3>Support Us</h3>
          <p>
            <router-link to="/donate" class="donate-link"
              >Make a Donation</router-link
            >
          </p>
          <div class="social-links">
            <a
              href="https://www.instagram.com/thehollowaynorwich"
              class="social-link"
            >
              <font-awesome-icon :icon="['fab', 'instagram']" /> Instagram
            </a>
            <a
              href="https://open.spotify.com/user/31reem4xwmrz4kk3vs56xpsj2p5m?si=d3e5450fe54f4ed4"
              class="social-link"
            >
              <font-awesome-icon :icon="['fab', 'spotify']" /> Spotify
            </a>
            <a
              href="https://www.youtube.com/channel/UC8sU9WBOY_M-xLFOUM9kgEQ"
              class="social-link"
            >
              <font-awesome-icon :icon="['fab', 'youtube']" /> YouTube
            </a>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p>&copy; 2024 Folklore Bookshop. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInstagram,
  faYoutube,
  faSpotify,
} from "@fortawesome/free-brands-svg-icons";

// Add the specific icons to the library
library.add(faInstagram, faYoutube, faSpotify);
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";

.site-footer {
  background-color: rgb(242, 253, 247);
  color: $text-color;
  padding: $spacing-lg $spacing-sm;
  margin-top: $spacing-xl;
  width: 100%;
  box-sizing: border-box;
  border-top: 1px solid #e0e0e0;

  .container {
    width: 100%;
    max-width: 100%;
    padding: 0 $spacing-sm;
    box-sizing: border-box;
    margin: 0 auto;

    @media (min-width: $breakpoint-md) {
      max-width: 1200px;
      padding: 0;
    }
  }
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: $spacing-lg;
  margin-bottom: $spacing-lg;
  text-align: center;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: $breakpoint-md) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    text-align: left;
  }
}

.footer-section {
  h3 {
    color: $tertiary-color;
    font-size: 1.3rem;
    margin-bottom: $spacing-md;
    font-family: $font-family-main;
    font-weight: 600;

    @media (min-width: $breakpoint-md) {
      font-size: 1.5rem;
    }
  }

  p {
    margin-bottom: $spacing-sm;
    color: $text-color;
  }
}

.social-links {
  margin-top: $spacing-sm;
  display: flex;
  flex-direction: column;
  gap: $spacing-xs;
  align-items: center;

  @media (min-width: $breakpoint-md) {
    align-items: flex-start;
  }

  .social-link {
    color: $tertiary-color;
    text-decoration: none;
    transition: color 0.3s ease;
    display: flex;
    align-items: center;
    gap: $spacing-xs;

    svg {
      font-size: 1.2rem;
    }

    &:hover {
      color: darken($tertiary-color, 10%);
    }
  }
}

.footer-bottom {
  text-align: center;
  padding-top: $spacing-md;
  border-top: 1px solid #e0e0e0;

  p {
    color: $text-color;
    opacity: 0.7;
    font-size: 0.9rem;
  }
}

.donate-link {
  color: $tertiary-color;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    color: darken($tertiary-color, 10%);
  }
}

.events-link {
  color: $tertiary-color;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    color: darken($tertiary-color, 10%);
  }
}
</style>
